module.exports = __webpack_public_path__ + "static/media/orphanslogo.9e6e6791.png";